import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import classNames from "classnames";
import "./index.scss";

import { DebounceInput } from "react-debounce-input";
import {
  getAddressSuggestions,
  getNotes,
  getAddress,
  locationIsEmpty,
  fillLocationFromPlace
} from "../../../services/order";
import { isNullOrWhitespace, isValidKey } from "../../../utils/objects-util";
import { getAddressSearchRadius } from "../../../services/restaurant";

class AddressAutocomplete extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchAddress: "",
      suggestedAddresses: [],
      lastSuggestedAddress: "",
      isDropdownOpen: false
    };

    this.ref = createRef();
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleOnKeyDown);
    document.addEventListener("click", this.handleClickOutside);
  }

  componentDidUpdate(prevProps, prevState) {
    const { searchAddress } = this.state;
    if(!prevProps.value && (prevProps.value !== searchAddress)) {
      this.setState({ searchAddress: "" })
    }
  }

  componentWillUnmount() {
    try {
      document.removeEventListener("keydown", this.handleOnKeyDown);
      document.removeEventListener("click", this.handleClickOutside);
    } catch(e) {}
  }

  handleOnKeyDown = event => {
    if (event.key === "Escape") {
      const { isDropdownOpen } = this.state;
      if (isDropdownOpen) {
        this.setState({ isDropdownOpen: false });
      }
    }
  };

  handleClickOutside = event => {
    if (this.ref && this.ref.current && !this.ref.current.contains(event.target))
      this.setState({ isDropdownOpen: false });
  };

  suggestAddresses = address => {
    const { lastSuggestedAddress } = this.state;
    const { countryCode, city, depotId, onSuggestionsChanged, onSuggestionEnd } = this.props;
    const searchAddress = address || this.state.searchAddress;

    if (!searchAddress) {
      this.setState({ suggestedAddresses: [] });
      return;
    }

    if (lastSuggestedAddress === searchAddress) return;

    this.setState({ lastSuggestedAddress: searchAddress });
    getAddressSuggestions(searchAddress, city, countryCode, false, getAddressSearchRadius(depotId)).then(suggestions => {
        this.setState({ suggestedAddresses: suggestions, isDropdownOpen: true });
        onSuggestionsChanged && onSuggestionsChanged(suggestions);
        onSuggestionEnd && onSuggestionEnd();
      }, () => {
        this.setState({ suggestedAddresses: [] });
        onSuggestionsChanged && onSuggestionsChanged([]);
        onSuggestionEnd && onSuggestionEnd();
      }
    );
  };

  handleOnChangeSearch = value => {
    const { handleOnChange, onSuggestionEnd } = this.props;
    const { searchAddress } = this.state;
    const oldVal = searchAddress;
    const newVal = value;

    if(isNullOrWhitespace(value))
      onSuggestionEnd && onSuggestionEnd();
    this.setState({ searchAddress: value }, () => {
      handleOnChange(value);
      if (newVal !== oldVal) {
        this.suggestAddresses(newVal);
      }

      onSuggestionEnd && onSuggestionEnd();
    });
  };

  handleOnSelect = variantAddress => {
    const { handleSelect } = this.props;
    if (variantAddress) {
      if (locationIsEmpty(variantAddress.location)) {
        fillLocationFromPlace(
          variantAddress.location,
          variantAddress.address
        ).then(
          data => {
            let { address, location } = data;
            if (address && !address.city) {
              address.city = variantAddress.address.city;
              address.street = variantAddress.address.street;
            }

            handleSelect(
              address && location ? { address, location } : variantAddress
            );
            this.setState({ isDropdownOpen: false });
          },
            () => {
            handleSelect(variantAddress);
            this.setState({ isDropdownOpen: false });
          }
        );
      }
    }
  };

  handleOnDebounceInputClick = () => {
    const { isDropdownOpen, suggestedAddresses } = this.state;
    if (isDropdownOpen) {
      this.setState({ isDropdownOpen: false });
    } else {
      if (suggestedAddresses.length > 0) {
        this.setState({ isDropdownOpen: true });
      }
    }
  };

  handleOnFocus = () => {
    const { onFocus } = this.props;

    if(onFocus) {
      onFocus();
    }
  }

  render() {
    const { readonly, debounce, value } = this.props;
    const { isDropdownOpen, searchAddress, suggestedAddresses } = this.state;

    return (
      <div className={classNames("dropdown")} ref={this.ref}>
        {readonly && (
          <input
            readOnly
            className={classNames("dropdownInput")}
            value={value || searchAddress}
          />
        )}
        {!readonly && (
          <DebounceInput
            className={classNames("dropdownInput")}
            debounceTimeout={debounce || 3000}
            onChange={event => this.handleOnChangeSearch(event.target.value)}
            onClick={this.handleOnDebounceInputClick}
            onKeyDown={event=> isValidKey(event.keyCode) && this.props.onSuggestionStart && this.props.onSuggestionStart()}
            value={value || searchAddress || ''}
            onFocus={this.handleOnFocus}
          />
        )}
        {!readonly &&
          isDropdownOpen && (
            <div className={classNames("dropdownItems")}>
              {suggestedAddresses.map((variant, index) => (
                <div
                  key={`variant=${index}`}
                  className={classNames("dropdownItem")}
                  onClick={() => this.handleOnSelect(variant)}
                >
                  {getNotes(variant.address) || getAddress(variant.address)}
                </div>
              ))}
            </div>
          )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  restaurant: state.restaurant.data
});

export default connect(mapStateToProps)(withTranslation()(AddressAutocomplete));
